import * as React from "react";
import * as styles from './IAProgressView.css';
import "../../styles/BasicIA.css";
import { LocalizationService } from '../../services/LocalizationService';
import { ProgressBar } from './progressBar/ProgressBar';
import { ProgressList } from "./progressList/ProgressList";
import { IProgressViewStatus } from "../../interfaces/IProgressViewStatus";

export interface IProgressViewProps {
  currentStep: number;
  totalSteps: number;
  stepsCompletedWithIssues: number[];
  status: IProgressViewStatus;
  onRetry?: () => void;
}

export interface IProgressViewState {
  currentStep: number;
  stepsCompletedWithIssues: number[];
}

export class IAProgressView extends React.Component<IProgressViewProps, IProgressViewState> {

  constructor(props: IProgressViewProps) {
    super(props);
    this.state = {
      currentStep: this.props.currentStep,
      stepsCompletedWithIssues: this.props.stepsCompletedWithIssues
    }
  }

  public componentWillReceiveProps(props: IProgressViewProps): void {
    if (props.currentStep !== this.props.currentStep) {
      this.setState({ currentStep: props.currentStep });
    }
    if (props.stepsCompletedWithIssues.length !== this.props.stepsCompletedWithIssues.length) {
      this.setState({ stepsCompletedWithIssues: props.stepsCompletedWithIssues });
    }
  }

  public render(): JSX.Element {
    let panel = (
      <div className={styles.IProgressView_Panel}>
        <div>
          <div className={styles.IProgressView_TitleContainer}>
            <div className={"IA_FontSize_24"}>
              {new LocalizationService().strings.ProgressView_Title}
            </div>
            <div>
              <p className={"IA_FontSize_14"}>{new LocalizationService().strings.ProgressView_Description}</p>
            </div>
          </div>
          <div
            className={styles.IProgressView_ProgressContainer}
            tabIndex={0}
          >
            <div className={styles.IProgressView_Img}>
              <ProgressBar
                backgroundColor={"#e3e3e3"}
                currentStep={this.state.currentStep}
                totalSteps={this.props.totalSteps}
                isCompleted={this.props.status === IProgressViewStatus.Completed}
              />
              <ProgressList
                currentStep={this.state.currentStep}
                stepsCompletedWithIssues={this.state.stepsCompletedWithIssues}
                status={this.props.status}
                onRetry={async () => this.props.onRetry()}
              />
            </div>
          </div>
          <div
            className={styles.IProgressView_ImageContainer}
            tabIndex={1}
          >
            <div
              className={styles.IProgressView_Img}
            >
              <img src={"https://intraactivestorage.blob.core.windows.net/cdn/SDK Images/wizard5.svg"} />
            </div>
          </div>
        </div>
      </div>);

    return panel;
  }
}
